/* eslint-disable @next/next/no-img-element */
"use client";

import Image from "next/image";
import Link from "next/link";
// import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useRef } from "react";
import { CommonNinjaWidgetRenderer } from "../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp";
import { CustomLink } from "../link/link.comp";
import { ParallaxEditor } from "../parallax-editor/parallax-editor.comp";
import { SocialProof } from "../socialProof/socialProof.comp";
import { StyledHero, StyledTrustedTitle } from "./hero.styles";
import { trackEvent } from "@/lib/track";

// Labels shown in the hero; `category` must match a category name in the
// /widgets catalog (used as the ?category= filter value).
const widgetCategories = [
  { label: "Reviews", category: "Reviews" },
  { label: "Social Feeds", category: "Social Feeds" },
  { label: "Forms", category: "Forms" },
  { label: "Popups & Buttons", category: "Popups, Bars & Buttons" },
  { label: "E-Commerce", category: "E-Commerce" },
  { label: "Media", category: "Media" },
];

export const Hero = () => {
  const ref: any = useRef<HTMLImageElement>();
  // const homepageHeroCTAVariant = useFeatureFlagVariantKey(
  //   "homepage---hero-cta-text"
  // );

  return (
    <>
      <StyledHero>
        <div className="hero-content-container">
          <div className="header-background-overlay">
            {/* left */}
            <div
              style={{ width: 59, height: 67 }}
              className="shadow-left-L left shadow"
            ></div>
            <div
              style={{ width: 30, height: 30 }}
              className="shadow-left-M a left shadow"
            ></div>
            <div
              style={{ width: 32, height: 33 }}
              className="shadow-left-M b left shadow"
            ></div>
            <div
              style={{ width: 21, height: 22 }}
              className="shadow-left-S left shadow"
            ></div>
            <Image
              src="/assets/hero/graph.png"
              alt="graph"
              className="graph"
              width={92}
              height={94}
            />
            <Image
              src="/assets/hero/star.png"
              alt="star"
              className="star"
              width={130}
              height={160}
            />
            <Image
              src="/assets/hero/watch.png"
              alt="watch"
              className="watch"
              width={75}
              height={76}
            />

            {/* right */}
            <div
              style={{ width: 71, height: 82 }}
              className="shadow-right-L right shadow"
            ></div>
            <div
              style={{ width: 34, height: 39 }}
              className="shadow-right-M right shadow"
            ></div>
            <div
              style={{ width: 19.5, height: 21 }}
              className="shadow-right-S right shadow"
            ></div>
            <Image
              src="/assets/hero/play.png"
              alt="play"
              className="play"
              width={80}
              height={82}
            />
            <Image
              src="/assets/hero/music.png"
              alt="music"
              className="music"
              width={65}
              height={65}
            />
            <Image
              ref={ref}
              src="/assets/hero/chat.png"
              alt="chat"
              className="chat"
              width={84}
              height={86}
            />
          </div>

          <div className="hero-proof-pill">
            <SocialProof avatarSize="medium" />
          </div>
          <h1 className="hero-title">
            The No-Code <span className="gradient-phrase">Widget Builder</span>{" "}
            <span className="second-line">for Any Website</span>
          </h1>
          <p className="title-description">
            200+ no-code widgets including reviews, social feeds, audio
            players, booking widgets, chatbots, forms, countdown timers,
            popups, and more to boost conversions, capture leads, and build
            trust.
          </p>

          <CustomLink
            variant="gradient"
            href="/signup"
            title="Signup for free"
            onClick={() => {
              trackEvent("Start creating hero");
              trackEvent("homepage_hero_cta_click");
            }}
          >
            Start for Free
          </CustomLink>
          <div className="rating-scores">
            <span className="score">
              <span className="star" aria-hidden="true">
                ★
              </span>{" "}
              <strong>4.9</strong> on Google
            </span>
            <span className="divider" aria-hidden="true">
              ·
            </span>
            <span className="score">
              <span className="star" aria-hidden="true">
                ★
              </span>{" "}
              <strong>4.3</strong> on Trustpilot
            </span>
          </div>
          <nav className="category-links" aria-label="Widget categories">
            {widgetCategories.map((cat) => (
              <Link
                key={cat.category}
                href={`/widgets?category=${encodeURIComponent(cat.category)}`}
                title={`${cat.label} widgets`}
              >
                {cat.label}
              </Link>
            ))}
            <Link className="all-widgets" href="/widgets" title="All widgets">
              All Widgets <span aria-hidden="true">→</span>
            </Link>
          </nav>
        </div>
      </StyledHero>
      <ParallaxEditor style={{ marginBottom: "80px" }} />
      <StyledTrustedTitle>
        Trusted by the world&apos;s leading brands
      </StyledTrustedTitle>
      <CommonNinjaWidgetRenderer
        widgetId={"87cf32fd-d8c2-4a3b-8cfc-0f419c000fbf"}
      />
    </>
  );
};
